import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Globe, Zap, ArrowUpRight } from 'lucide-react';
import { COLORS } from '../../../constants/dashboard';

const ImpactWebsiteView = ({ businessProfile, campaigns, stats, user }) => {
  const navigate = useNavigate();
  const businessId = businessProfile?.business_id || user?.business_id;

  const handlePreview = () => {
    if (businessId) {
      window.open(`/impact/${businessId}`, '_blank');
    } else {
      alert('Business profile not loaded yet. Please try again.');
    }
  };

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Impact Website</h2>
          <p className="text-gray-500">Create a public-facing website showcasing your CSR efforts</p>
        </div>
        <div className="flex gap-2">
          <button 
            onClick={handlePreview}
            className="px-4 py-2 border rounded-xl font-medium text-gray-600 hover:bg-gray-50 flex items-center gap-2"
          >
            Preview <ArrowUpRight className="w-4 h-4" />
          </button>
          <button 
            onClick={() => navigate('/builder')}
            className="px-4 py-2 rounded-xl font-semibold text-white flex items-center gap-2"
            style={{ background: COLORS.primary }}
          >
            <Zap className="w-4 h-4" /> Customize
          </button>
        </div>
      </div>
      
      <div className="bg-white rounded-2xl p-8 shadow-sm border text-center">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4" style={{ background: `${COLORS.primary}15` }}>
          <Globe className="w-10 h-10" style={{ color: COLORS.primary }} />
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">Your Impact Website</h3>
        <p className="text-gray-500 mb-6 max-w-md mx-auto">
          Showcase your company&apos;s charitable giving, campaigns, and overall social impact to the public.
        </p>
        <button
          onClick={() => navigate('/builder')}
          className="px-6 py-3 text-white rounded-xl font-semibold hover:opacity-90 transition-all"
          style={{ background: COLORS.primary }}
        >
          Customize Your Website →
        </button>
      </div>
      
      {/* Quick Stats */}
      <div className="grid grid-cols-3 gap-4 mt-6">
        <div className="bg-white rounded-xl p-5 shadow-sm border">
          <p className="text-3xl font-bold text-gray-900">{campaigns.filter(c => c.status === 'active').length}</p>
          <p className="text-sm text-gray-500">Active Campaigns on Site</p>
        </div>
        <div className="bg-white rounded-xl p-5 shadow-sm border">
          <p className="text-3xl font-bold text-gray-900">${(stats?.total_raised || 0).toLocaleString()}</p>
          <p className="text-sm text-gray-500">Total Impact Displayed</p>
        </div>
        <div className="bg-white rounded-xl p-5 shadow-sm border">
          <p className="text-3xl font-bold text-green-600">{businessProfile?.website_published ? 'Live' : 'Draft'}</p>
          <p className="text-sm text-gray-500">Website Status</p>
        </div>
      </div>
    </div>
  );
};

export default ImpactWebsiteView;
